import { render, staticRenderFns } from "./IconZonneEnergieVinkje.vue?vue&type=template&id=02206456"
import script from "./IconZonneEnergieVinkje.vue?vue&type=script&lang=ts"
export * from "./IconZonneEnergieVinkje.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports